/**
 * @fileoverview Connect shared notification requests to the mounted toast surface. `ToastContext.js` exposes the caller interface and workspaces own message content. Provider lifetime owns presentation resources without acknowledging backend completion or replacing durable error/audit records. It also shows the upload-checking and held notices that `fileAdmissionTransport.js` announces through `kc-file-admission` window events.
 */

import React, { useEffect, useRef } from 'react';
import { Toast } from './components/shared/AppToast';
import ToastContext from './ToastContext';



const ToastProvider = ({ children }) => {
    const toast = useRef(null);

    useEffect(() => {
        const listener = event => {
            if (event.detail?.state === 'pending') toast.current?.show({ severity: 'info', summary: 'Checking upload', life: 5000 });
            if (event.detail?.state === 'held') toast.current?.show({ severity: 'warn', summary: 'Upload held', detail: 'Contact your legal team for help.', life: 8000 });
        };
        window.addEventListener('kc-file-admission', listener);
        return () => window.removeEventListener('kc-file-admission', listener);
    }, []);

    const showToast =

    ({ severity, summary, detail, life = 3000 }) => {
        toast.current.show({ severity, summary, detail, life });
    };

    return (
        <ToastContext.Provider value={showToast}>
            <Toast ref={toast} />
            {children}
        </ToastContext.Provider>
    );
};

export default ToastProvider;
